
export default function getTipInfo(resp) {
    let tipInfo = {};
	if(resp) {
        if(resp.flag || resp.code == 200 || (!resp.code && !resp.message && !resp.Message)) {
            tipInfo.type = 'success';
            tipInfo.message = resp.message;
        }else{
            tipInfo.type = 'error';
            tipInfo.message = resp.message;
        }
    }else{
        tipInfo.type = 'error';
        tipInfo.message = resp ? resp.message : '';
    }
    return tipInfo;
}



// WEBPACK FOOTER //
// ./src/components/Button/getTipInfo.js